import React from "react";
import { Layout } from "antd";

import "./Footer.scss";

const { Footer } = Layout;

const AppFooter = () => {
  const date = new Date().getFullYear();

  return (
    <Footer className="footer">
      {/* <div className="footer__text">© {date} Averroes.AI</div> */}
      <div className="footer__text">Copyright © {date} Averroes.ai. All rights reserved</div>
    </Footer>
  );
};

export default React.memo(AppFooter);
